

define(['squid/index', 'jquery'], function (squid, $) {

    $.fn.dropdown = function () {
        console.warn('Dropdown deprecated');
    };

    squid.module('xo-dropdown.directive', ['squid']).directive('xoDropdown', function ($parse, $window, $timeout, $injector, $rootScope, $config, $locale, $experiment) {

        var userAgent = ($window.navigator || {}).userAgent;
        var isWinOS = Boolean(userAgent.match(/\(win/i));

        return {

            restrict: 'A',

            link: function link($scope, $element, attrs) {

                var $select = $($element);

                var selectInitialValue = '';

                var ngChange = '';
                var $span = $('<span class="custom-select" aria-hidden="true"><span><span></span></span></span>');

                $select.parent().addClass('custom-select-container');

                // Change class names to enable styling of hover/focus states
                $select.bind('mouseenter', function () {
                    $span.addClass('active');
                });

                // Change class names to enable styling of hover/focus states
                $select.bind('focus', function () {
                    selectInitialValue = $parse(attrs.ngModel)($scope);
                    $span.addClass('active');
                });

                // Change class names to enable styling of hover/focus states
                $select.bind('mouseleave', function () {
                    $span.removeClass('active');
                });

                function executeSelectChange() {
                    // setTimeout here is to ensure activeElement is set before our function executes
                    $timeout(function () {
                        var val = $parse(attrs.ngModel)($scope);
                        if (selectInitialValue !== val) {
                            if (ngChange) {
                                ngChange($scope);
                            }
                            selectInitialValue = val;
                        }
                    }, 10);
                }

                if (isWinOS) {
                    if (attrs['ngChange']) {
                        ngChange = $parse(attrs.ngChange);
                        attrs['ngChange'] = '';
                    }

                    $select.bind('blur', function () {
                        executeSelectChange();
                        $span.removeClass('active');
                    });

                    $select.bind('click', function () {
                        executeSelectChange();
                    });
                } else {
                    $select.bind('blur', function () {
                        $span.removeClass('active');
                    });
                }

                $select.after($span);

                $select.addClass('replaced');

                if (attrs['default']) {
                    var defaultOption = document.createElement('option');
                    defaultOption.innerText = attrs['default'];
                    $select.append(defaultOption);
                }

                function updateCover() {
                    $timeout(function () {
                        $span.find('span span').text($select.find(':selected').text().trim());
                    }, 10);
                }

                // Update cover on arrow key press, for case where menu is not open
                // but user is interacting with dropdown (eg. Firefox)
                $select.bind('keyup', function (event) {
                    // Arrow keys are 37 - 40
                    if (event.which >= 37 || event.which <= 40) {
                        updateCover();
                    }
                });

                $scope.$watch(attrs.ngModel, updateCover);
                $scope.$on('contentChange', updateCover);

                var match = (attrs.ngOptions || '').match(/in ([\w\.]+)/);
                if (match) {
                    $scope.$watch(match[1], updateCover);
                }
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-ui-components/src/dropdown/directive.js
 ** module id = 257
 ** module chunks = 1
 **/